import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import Button from '../common/Button';
import styled from 'styled-components';

const ButtonA = styled(Button)`
  background: #324971;
  color: #fff;
`;
const ButtonB = styled(Button)`
  background: #7A062D;
  color: #fff;
`;

class NewParticipantForm extends React.Component {
  state = {
    gender: '0',
    currentAge: '0',
    yearsOfEducation: '0',
    diagnosis: '0',
    diseaseSubtype: '0',
    yearsSinceDiagnosis: '0',
    centreNo: '',
    dateValid: moment(),
    errors: {},
    loading: false,
    verification: false,
    infoCorrectAsOf: moment().format("DD-MMM-YYYY"),
    genderLabel: '',
    centreNoLabel: ''
  }

  

  handleChange = (e) => {
    if (!!this.state.errors[e.target.name]) {
      let errors = Object.assign({}, this.state.errors);
      delete errors[e.target.name];
      this.setState({
        [e.target.name]: e.target.value,
        errors
      });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    // validation
    let errors = {};
    if (this.state.gender === "0") errors.gender = "This is required";
    if (this.state.currentAge === "0") errors.currentAge = "This is required";
    if (this.state.yearsOfEducation === "0") errors.yearsOfEducation = "This is required";
    if (this.state.diagnosis === "0") errors.diagnosis = "This is required";
    if (this.state.diseaseSubtype === "0") errors.diseaseSubtype = "This is required";
    if (this.state.yearsSinceDiagnosis === "0") errors.yearsSinceDiagnosis = "This is required";
    if (this.state.centreNo !== "" && /^[0-9]{6,6}$/.test(this.state.centreNo) !== true) errors.centreNo = "Please enter a 6 digit number";
    this.setState({ errors });
    const isValid = Object.keys(errors).length === 0;

    if (isValid) {
      this.setState({ 
        verification: true, 
        genderLabel: this.state.gender === "1" ? "Male" : "Female", 
        centreNoLabel: this.state.centreNo !== "" ?  this.state.centreNo : "N/A" 
      });
    }
  }

  confirmVerification = (e) => {
    e.preventDefault();
    const { gender, currentAge, yearsOfEducation, diagnosis, diseaseSubtype, yearsSinceDiagnosis, centreNo, dateValid  } = this.state;
      this.setState({ loading: true });
      this.props.saveParticipant({ gender, currentAge, yearsOfEducation, diagnosis, diseaseSubtype, yearsSinceDiagnosis, centreNo, dateValid })
        .catch((err) => err.response.json().then(({errors}) => this.setState({ errors, loading: false })));
        // err.response.json();
  }

  denyVerification = (e) => {
    e.preventDefault();
    this.setState({ verification: false });
  }

  render() {
    const form = (
      <div>
        <div className="row">
          <div className="col-md-12">
            <h1 className="bicamsColor">Enter a new BICAMS Participant</h1>
            <h2 className="bicamsColor">Information correct as of {this.state.infoCorrectAsOf}</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <form className={classnames('ui', 'form', { loading: this.state.loading })} onSubmit={this.handleSubmit}>

              {!!this.state.errors.global && <div className="ui negative message"><p>{this.state.errors.global}</p></div>}
              <div className="row">  
              <fieldset className="col-sm-6">

              <legend>Demographic Information</legend>
              <div className={classnames('field', { error: !!this.state.errors.gender})}>
                <select name="gender" className="selectForm" value={this.state.gender} onChange={this.handleChange}>
                  <option value="0">Gender*</option>
                  <option value="1">Male</option>
                  <option value="2">Female</option>
                </select>
                <span>{this.state.errors.gender}</span>
              </div>
              <div className={classnames('field', { error: !!this.state.errors.currentAge})}>
                <select name="currentAge" className="selectForm" value={this.state.currentAge} onChange={this.handleChange}>
                  <option value="0">Current Age*</option>
                  <option value="18">18</option>
                  <option value="19">19</option>
                  <option value="20">20</option>
                  <option value="21">21</option>
                  <option value="22">22</option>
                  <option value="23">23</option>
                  <option value="24">24</option>
                  <option value="25">25</option>
                  <option value="26">26</option>
                  <option value="27">27</option>
                  <option value="28">28</option>
                  <option value="29">29</option>
                  <option value="30">30</option>
                  <option value="31">31</option>
                  <option value="32">32</option>
                  <option value="33">33</option>
                  <option value="34">34</option>
                  <option value="35">35</option>
                  <option value="36">36</option>
                  <option value="37">37</option>
                  <option value="38">38</option>
                  <option value="39">39</option>
                  <option value="40">40</option>
                  <option value="41">41</option>
                  <option value="42">42</option>
                  <option value="43">43</option>
                  <option value="44">44</option>
                  <option value="45">45</option>
                  <option value="46">46</option>
                  <option value="47">47</option>
                  <option value="48">48</option>
                  <option value="49">49</option>
                  <option value="50">50</option>
                  <option value="51">51</option>
                  <option value="52">52</option>
                  <option value="53">53</option>
                  <option value="54">54</option>
                  <option value="55">55</option>
                  <option value="56">56</option>
                  <option value="57">57</option>
                  <option value="58">58</option>
                  <option value="59">59</option>
                  <option value="60">60</option>
                  <option value="61">61</option>
                  <option value="62">62</option>
                  <option value="63">63</option>
                  <option value="64">64</option>
                  <option value="65">65</option>
                </select>
                <span>{this.state.errors.currentAge}</span>
              </div>
              <div className={classnames('field', { error: !!this.state.errors.yearsOfEducation})}>
                <select name="yearsOfEducation" className="selectForm" value={this.state.yearsOfEducation} onChange={this.handleChange}>
                  <option value="0">Years of Education*</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                  <option value="16">16</option>
                  <option value="17">17</option>
                  <option value="18">18</option>
                  <option value="19">19</option>
                  <option value="20">20</option>
                </select>
                <span>{this.state.errors.yearsOfEducation}</span>
              </div>

               </fieldset>  

               <fieldset className="col-sm-6">

              <legend>Clinical Information</legend>
              <div className={classnames('field', { error: !!this.state.errors.yearsSinceDiagnosis})}>
                <select name="yearsSinceDiagnosis" className="selectForm" value={this.state.yearsSinceDiagnosis} onChange={this.handleChange}>
                  <option value="0">Years Since Diagnosis*</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                  <option value="16">16</option>
                  <option value="17">17</option>
                  <option value="18">18</option>
                  <option value="19">19</option>
                  <option value="20">20</option>
                </select>
                <span>{this.state.errors.yearsSinceDiagnosis}</span>
              </div>
              <div className={classnames('field', { error: !!this.state.errors.diseaseSubtype})}>
                <select name="diseaseSubtype" className="selectForm" value={this.state.diseaseSubtype} onChange={this.handleChange}>
                  <option value="0">Disease sub-type*</option>
                  <option value="CIS">CIS</option>
                  <option value="RR">RR</option>
                  <option value="SP">SP</option>
                  <option value="PP">PP</option>
                </select>
                <span>{this.state.errors.diseaseSubtype}</span>
              </div>
              <div className={classnames('field', { error: !!this.state.errors.diagnosis})}>
                <select name="diagnosis" className="selectForm" value={this.state.diagnosis} onChange={this.handleChange}>
                  <option value="0">Diagnosis*</option>
                  <option value="Definite CIS/MS">Definite CIS/MS</option>
                  <option value="Possible CIS/MS">Possible CIS/MS</option>
                </select>
                <span>{this.state.errors.diagnosis}</span>
              </div>

              <div className={classnames('field', { error: !!this.state.errors.centreNo})}>
                <input
                  name="centreNo"
                  value={this.state.centreNo}
                  onChange={this.handleChange}
                  id="centreNo"
                  className="selectForm"
                  placeholder="Centre Number (if applicable)"
                />
                <span>{this.state.errors.centreNo}</span>
              </div>

              </fieldset>  
              </div>

              <div className="field text-center">
                <ButtonA className="btn btn-lg">Submit New Participant</ButtonA>
                <p>Fields marked with a * are mandatory</p>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
    return (
      <div>
        { this.state.verification ? 
        <div>
          <div className="row">
            <div className="col-md-12">
              <h1 className="bicamsColor">Verify New Participant Information</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <h2 className="bicamsColor">Information correct as of {this.state.infoCorrectAsOf}</h2>
              <p><strong>Gender: </strong> {this.state.genderLabel}</p>
              <p><strong>Age: </strong> {this.state.currentAge}</p>
              <p><strong>Years of Education: </strong> {this.state.yearsOfEducation}</p>
              <p><strong>Diagnosis: </strong> {this.state.diagnosis}</p>
              <p><strong>Disease Sub-type: </strong> {this.state.diseaseSubtype}</p>
              <p><strong>Years Since Diagnosis: </strong> {this.state.yearsSinceDiagnosis}</p>
              <p><strong>Centre number: </strong> {this.state.centreNoLabel}</p>
              <ButtonA className="btn btn-lg" type="button" onClick={this.confirmVerification}>Yes, This is Correct</ButtonA>
              <ButtonB className="btn btn-lg" type="button" onClick={this.denyVerification}>No, This is Incorrect</ButtonB>
            </div>
          </div>
        </div>
        :
        form }
      </div>
    );
  }
}


export default NewParticipantForm;


// WEBPACK FOOTER //
// ./src/components/participants/NewParticipantForm.js